import { ApplicationRejectPopupQuestion } from "../interfaces/application-reject-popup-question.interface";

export class ApplicationRejectRequest implements ApplicationRejectPopupQuestion {
    constructor(
        public id: string,
        public applicationRejectionReasonTypeId: string,
        public applicationRejectionComments: string
      ) { }
}
